"use client";
import * as React from "react";

import { CaptionProps, useDayPicker, useNavigation } from "react-day-picker";
import { LeftArrow, RightArrow } from "./arrow";
import classNames from "classnames";
import { isSameMonth } from "date-fns";
import { Container, Typography } from "ct-design";

export function Caption(props: CaptionProps): JSX.Element {
  const {
    locale,
    formatters: { formatCaption },
  } = useDayPicker();

  const { goToMonth, nextMonth, previousMonth, displayMonths } =
    useNavigation();
  const displayIndex = displayMonths.findIndex((month) =>
    isSameMonth(props.displayMonth, month)
  );

  const isFirst = displayIndex === 0;
  const isLast = displayIndex === displayMonths.length - 1;

  const handlePreviousClick: React.MouseEventHandler = () => {
    if (!previousMonth) return;
    goToMonth(previousMonth);
  };

  const handleNextClick: React.MouseEventHandler = () => {
    if (!nextMonth) return;
    goToMonth(nextMonth);
  };

  return (
    <Container className="flex flex-row flex-between w-100p flex-middle">
      {isFirst ? (
        <Container className={classNames(" w-100p flex-1")}>
          <Container className="flex flex-row flex-center">
            <LeftArrow
              data-testid="leftArrow"
              height={24}
              width={24}
              className="c-pointer c-neutral-900"
              onClick={handlePreviousClick}
            />
          </Container>
        </Container>
      ) : (
        <Container className={classNames(" flex w-100p ta-left")}></Container>
      )}
      {isLast && displayIndex > 0 && (
        <Container
          className="p-absolute"
          style={{
            left: "50%",
            height: "250px",
            borderLeft: "1px dotted rgb(187, 187, 187)",
          }}
        ></Container>
      )}
      {
        <Container className="flex flex-center w-100p">
          <Typography variant="HM3">
            {formatCaption(props.displayMonth, { locale })}
          </Typography>
        </Container>
      }
      {
        <Container className={classNames("flex ta-right  flex-middle")}>
          {isLast && (
            <RightArrow
              disabled={!nextMonth}
              data-testid="rightArrow"
              height={24}
              width={24}
              style={{ alignSelf: "flex-end" }}
              className="c-pointer c-neutral-900"
              onClick={handleNextClick}
            />
          )}
        </Container>
      }
    </Container>
  );
}
